import React from 'react'
import PropTypes from 'prop-types'
import {
  Message,
  MessageBox,
  MessageContainer,
  Reply,
  ReplyMessageContainer,
  UserIcon,
  ModeratorIcon,
  UserIconContainer,
  Username,
} from '../style'
import MessageWithLink from './MessageWithLink'
import { CustomerRoles } from '../../../constants/customerRoles'

export const RepliedMessage = React.memo(function RepliedMessage({
  message,
  getModeratorColorByUsername,
  isDesktop,
}) {
  const showMessage = message.type !== 'deleted' && message.reply !== null && message !== null

  return (
    <>
      {showMessage && (
        <MessageContainer isDesktop={isDesktop}>
          <UserIconContainer>
            <UserIcon isDesktop={isDesktop} />
          </UserIconContainer>
          <Username
            color={
              message.reply.role === CustomerRoles.MODERATOR
                ? getModeratorColorByUsername(message.reply.username)
                : undefined
            }
            isDesktop={isDesktop}
          >{`${message.reply.username}: `}</Username>
          <Message isDesktop={isDesktop}>{message.reply.text}</Message>
          <ReplyMessageContainer isDesktop={isDesktop}>
            <Reply isDesktop={isDesktop} />
            <ModeratorIcon isDesktop={isDesktop} />
            <MessageBox>
              <Username
                data-test="username-inner-chat"
                // no se valida el rol ya que el unico usuario que tiene permisos para enviar un mensaje de tipo reply es el moderador
                color={getModeratorColorByUsername(message.username)}
                isDesktop={isDesktop}
              >
                {`${message.username}: `}
              </Username>
              <MessageWithLink logType="click-url-in-chat" isDesktop={isDesktop}>
                <Message isDesktop={isDesktop}>{message.text}</Message>
              </MessageWithLink>
            </MessageBox>
          </ReplyMessageContainer>
        </MessageContainer>
      )}
    </>
  )
})

RepliedMessage.propTypes = {
  isDesktop: PropTypes.bool,
  message: PropTypes.object.isRequired,
  getModeratorColorByUsername: PropTypes.func,
}
